// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Tooltip } from '@mui/material';
import { IconButton } from '@shared/ui-kit/components/icon-button';
import { useTranslation } from 'react-i18next';

interface TagItemProps {
  label: string;
  tag: string;
  ticker?: string;
  'data-testid'?: string;
  onDelete:
    | ((tag: string, ticker: string) => void)
    | ((tag: string, ticker?: string) => void);
}

export const TagItem = ({
  label,
  tag,
  ticker,
  'data-testid': testId,
  onDelete,
}: TagItemProps) => {
  const { t } = useTranslation();
  return (
    <div
      className="flex h-[28px] w-[170px] cursor-default flex-row items-center justify-between rounded-full bg-primary !px-3 !py-2 text-base text-white"
      data-testid={testId}
    >
      <Tooltip title={label}>
        <span className="line-clamp-1">{label}</span>
      </Tooltip>
      <Tooltip title={t('tag-manager.delete-tag', { ns: 'components' })}>
        <IconButton
          variant="icon"
          icon="Trashcan"
          color="light"
          size="base"
          data-testid="delete-tag-button"
          onClick={() => onDelete(tag, ticker!)}
        />
      </Tooltip>
    </div>
  );
};
